export default function YouTubeIcon({}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      fill="#B2D4FB"
      aria-hidden="true"
      role="img"
    >
        <g transform="translate(0,2)">
    <path d="M23.497 6.186a3.01 3.01 0 0 0-2.116-2.126C19.74 3.5 12 3.5 12 3.5s-7.74 0-9.381.56A3.01 3.01 0 0 0 .503 6.186 31.39 31.39 0 0 0 0 12a31.39 31.39 0 0 0 .503 5.814 3.01 3.01 0 0 0 2.116 2.126C4.26 20.5 12 20.5 12 20.5s7.74 0 9.381-.56a3.01 3.01 0 0 0 2.116-2.126A31.39 31.39 0 0 0 24 12a31.39 31.39 0 0 0-.503-5.814zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/>
  </g>
    </svg>

  );
}
